<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Revenue Share Campaigns</p>
          <div class="float-right">
            <el-tooltip content="Insert" placement="top">
              <el-button
                  type="success"
                  circle
                  icon="el-icon-check"
                  @click="openModal(activeTab)"
                  class="ml10"
              ></el-button>
            </el-tooltip>
          </div>
        </div>
        <el-tabs type="border-card"  @tab-click="tabClick" v-model="tabs">
          <el-tab-pane label="Campaigns" name="campaigns">
            <CampaignTable />
            <CampaignDialog />
          </el-tab-pane>
          <el-tab-pane label="Track" name="track">
            <TrackTable />
            <TrackDialog />
          </el-tab-pane>
          <el-tab-pane label="Channels" name="channels">
            <ChannelTable />
            <ChannelDialog />
          </el-tab-pane>
          <el-tab-pane label="Reports" name="reports">
            <Reports />
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import CampaignTable from "@/modules/admin/cms/components/youtube/rev-share-campaigns/Table.vue";
import CampaignDialog from "@/modules/admin/cms/components/youtube/rev-share-campaigns/Dialog.vue";
import TrackTable from "@/modules/admin/cms/components/youtube/rev-share-tracks/Table.vue";
import TrackDialog from "@/modules/admin/cms/components/youtube/rev-share-tracks/Dialog.vue";
import ChannelTable from "@/modules/admin/cms/components/youtube/rev-share-channels/Table.vue";
import ChannelDialog from "@/modules/admin/cms/components/youtube/rev-share-channels/Dialog.vue";
import Reports from "@/modules/admin/cms/components/youtube/rev-share-reports/Reports.vue";

export default {
  components: {
    ChannelDialog,
    ChannelTable,
    CampaignTable,
    CampaignDialog,
    TrackTable,
    TrackDialog,
    Reports,
  },
  data() {
    return {
      tabs: 'campaigns'
    }
  },

  computed: {
    ...mapState('revShareCampaigns', ['loading', 'order_column', 'activeTab', 'showCampaignModal']),
  },

  methods: {
    ...mapMutations('revShareCampaigns', ['setCampaignModal', "setTrackModal",'setChannelModal', 'setActiveTab', 'setReportsModal']),
    tabClick(){
      this.setActiveTab(this.tabs)
    },
    openModal(tab) {
      if(tab === 'campaigns') {
        this.setCampaignModal(true);
      }
      else if (tab === 'track'){
        this.setTrackModal(true);
      }
      else if (tab === 'channels'){
        this.setChannelModal(true);
      }
      else if (tab === 'reports')
      {
        this.setReportsModal(true);
      }
    }
  },

}
</script>
